/*
 * @Author: lisl27
 * @Date: 2021-11-29 15:31:44
 * @LastEditors: lisl27
 * @LastEditTime: 2021-12-10 17:26:09
 * @Description: file content
 */
import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BasesController } from '../bases';
export class BusinessInfoController extends BasesController<any> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      details: EnumAPI.business_opportunityDetail,
      update: EnumAPI.business_addOpportunity,
      detailsParams: {
        valueGetter: this.valueGetter,
      },
    });
  }
  valueGetter = (response, AjaxConfig) => {
    const { opportunityBusiness, customerInfo, cmdbId } = response;
    const tempResponse = lodash.assign({}, opportunityBusiness, customerInfo, {
      cmdbId,
    });
    if (customerInfo.cityCode) {
      lodash.set(tempResponse, 'agentAddress', [
        {
          label: customerInfo.provinceName,
          value: customerInfo.provinceCode,
        },
        {
          label: customerInfo.cityName,
          value: customerInfo.cityCode,
        },
      ]);
    }
    return tempResponse;
  };
  /**
   * @des 保存商机信息
   */
  async onBusinessAddClient(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_addOpportunity,
      body,
    });
  }
  /**
   * @des 校验客户名称
   */
  async onBusinessExternalVerify(body) {
    return await AjaxBasics.request({
      ...EnumAPI.business_externalVerify,
      body,
    });
  }
}
